import jsPDF from 'jspdf';
import { ReportElementData, ReportElementDataScore } from './Report';

interface RGBColor {
    r: number;
    g: number;
    b: number;
}

const getInnerText = (text: string) => {
    const div = document.createElement('div');
    div.innerHTML = text;

    return div.innerText;
};

export const hexToRgb = (hex: string): RGBColor => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return {
        r: result ? parseInt(result[1], 16) : 0,
        g: result ? parseInt(result[2], 16) : 0,
        b: result ? parseInt(result[3], 16) : 0,
    };
};

export class Pdf {
    pdf: any;
    padding = 20;
    yPos = 20;
    width = 0;
    height = 0;
    page = 1;

    constructor() {
        this.pdf = new jsPDF('p', 'mm', 'a4');
        this.width = this.pdf.internal.pageSize.getWidth();
        this.height = this.pdf.internal.pageSize.getHeight();
    }

    setHeading(title: string, fontSize: number, color: RGBColor) {
        this.pdf.setTextColor(color.r, color.g, color.b);
        this.pdf.setFontSize(fontSize);
        this.pdf.text(this.padding, this.yPos, title);

        this.updateYPos(title);
    }

    setScorePoints(score: ReportElementDataScore, fontSize: number, color: RGBColor) {
        this.pdf.setTextColor(color.r, color.g, color.b);
        this.pdf.setFontSize(fontSize);
        this.pdf.text(
            this.padding,
            this.yPos,
            'Je hebt ' +
                score.points +
                ' van de ' +
                score.pointsMax +
                ' punten gehaald. Dit komt neer op een percentage van ' +
                score.score +
                '%.',
        );

        this.updateYPos(score.points.toString());
    }

    setScoreProgressBar(score: ReportElementDataScore, color: RGBColor) {
        this.pdf.setFillColor(233, 236, 239);
        this.pdf.roundedRect(this.padding, this.yPos, this.width - this.padding * 2, 5, 1, 1, 'F');
        this.pdf.setFillColor(color.r, color.g, color.b);
        this.pdf.roundedRect(
            this.padding,
            this.yPos,
            score.score * (this.width / 100) - this.padding * 2,
            5,
            1,
            1,
            'F',
        );
        this.pdf.setTextColor(255, 255, 255);
        this.pdf.setFontSize(8);
        this.pdf.text(this.padding + 5, this.yPos + 3.5, score.points + ' points');
        this.pdf.setTextColor(0, 0, 0);
        this.pdf.setFontSize(12);

        this.updateYPos(score.score.toString());
        this.updateYPos(' ');
    }

    parseHTML(body: string, fontSize: number) {
        let htmlArray = body.split('<br>');

        htmlArray = body.split('</p>').filter((str: string) => {
            return str.length;
        });

        htmlArray.map((str: string) => {
            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFontSize(fontSize);
            this.pdf.text(this.padding, this.yPos, getInnerText(str), {
                maxWidth: this.width - this.padding * 2,
            });
            this.updateYPos(str);
        });
    }

    setButton(params: ReportElementData, fontSize: number, color: RGBColor) {
        const textDimensions = this.pdf.getTextDimensions(params.label);

        this.pdf.setFillColor(color.r, color.g, color.b);
        this.pdf.setTextColor(255, 255, 255);
        this.pdf.setFontSize(fontSize);
        this.pdf.roundedRect(this.padding, this.yPos, textDimensions.w + 10, textDimensions.h + 5, 1, 1, 'F');

        if (params.url) {
            this.pdf.textWithLink(params.label, this.padding + 5, this.yPos + fontSize / 2, {
                url: params.url,
            });
        } else {
            this.pdf.text(this.padding + 5, this.yPos + 6.5, params.label);
        }

        if (params.description) {
            this.pdf.setTextColor(0, 0, 0);
            this.pdf.setFontSize(8);
            this.pdf.text(this.padding, this.yPos + textDimensions.h + 10, params.description);
            this.yPos += textDimensions.h + 6.5;
        }

        this.yPos += fontSize / 2 + 6.5;
    }

    save(title: string) {
        this.pdf.setProperties({
            title: title.replace(/ /g, '_') + ':' + new Date().getTime(),
        });

        window.open(this.pdf.output('bloburl'));

        this.yPos = 20;
    }

    updateYPos(text: string) {
        const innerText = getInnerText(text);
        const lineHeight = this.pdf.getLineHeight(innerText) / this.pdf.internal.scaleFactor;
        const width = this.width - this.padding * 2;
        const amountOfLines = this.pdf.splitTextToSize(innerText, width).length;
        const blockHeight = amountOfLines * lineHeight;

        this.yPos += blockHeight;

        if (this.yPos >= this.height - this.padding) {
            this.yPos = 20;
            this.pdf.addPage();
        }
    }
}
